import { type UIEvent, useState } from 'react';

/**
 * Reports whether a scroll container still sits against its top and left edges, so a table can attach its
 * sticky classes only once the reader has scrolled off one — driven by scroll position rather than by measuring
 * overflow, so a table that fits pays nothing.
 */
export const useStickyTableEdges = () => {
	const [isAtTopOfTable, setIsAtTopOfTable] = useState(true);
	const [isAtLeftOfTable, setIsAtLeftOfTable] = useState(true);

	const onScroll = (e: UIEvent<HTMLElement>) => {
		setIsAtTopOfTable(e.currentTarget.scrollTop === 0);
		setIsAtLeftOfTable(e.currentTarget.scrollLeft === 0);
	};

	return { isAtLeftOfTable, isAtTopOfTable, onScroll };
};
